<div class="heading-container">
  <span class="heading">{{ heading() }}</span>
  <span class="subheading">{{ subheading() }}</span>
</div>

<div class="content-container">
  <ng-content />
</div>

<div class="buttons-container">
  <rt-button variant="plain" (click)="stayWithTellent.emit()">
    {{ 'tlc.churn_flow.common.stay_with_tellent' | translate }}
  </rt-button>
  <rt-button variant="outline" class="danger-on-hover" (click)="stillWantToCancel.emit()">
    {{ 'tlc.churn_flow.common.still_want_to_cancel' | translate }}
  </rt-button>
</div>
